import { call } from 'redux-saga/effects';
import { UserId } from 'features/users/types';
import { hasPermissionsSaga } from 'features/permissions/sagas/hasPermissionsSaga';
import { PermissionTypes } from 'features/permissions/types';
import { eventBus } from 'utils/eventBus';

export function* sendWaitingUsersLeftSaga(userIds: UserId[]) {
  if (userIds.length === 0) {
    return;
  }

  const canControlRoomEntry: boolean = yield call(
    hasPermissionsSaga,
    PermissionTypes.controlRoomEntry
  );

  if (!canControlRoomEntry) {
    return;
  }

  yield call(eventBus.sendMessage, 'waitingUsersLeft', undefined, { userIds });
}
